import { parseExpression, evalNode } from './ast.js'

export function ejecutarExpresion(expresion, datos, errors = []) {
  const ast = parseExpression(expresion, errors)
  return evalNode(ast, datos, errors)
}
